import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import MainScreen from "src/Component/TV/MainScreen";
import FrameTV from "src/Component/FrameTV";
import BottomTV from "src/Component/BottomTV";

const PageId = 3;
const NextPageId = PageId + 1;
const BackPageId = PageId - 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);
  const [stepVisited, setStepVisited] = useState<number[]>([0]);
  const [showBtns, setShowBtns] = useState<boolean>(false);

  const registerStepVisited = (newStep: number) => {
    setStep((prev) => {
      setStepVisited((prevVisited) => {
        const count = prevVisited.filter((step) => step === newStep).length;
        if (count < 3) return [...prevVisited, newStep];
        return prevVisited;
      });

      return newStep;
    });
  };

  useEffect(() => {
    if (PageId === currentPage) {
      if (!stepVisited.includes(step)) setStepVisited((prev) => [...prev, step]);
    } else {
      setStep(0);
      setStepVisited([0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  useEffect(() => {
    if (currentPage === PageId && stepVisited.includes(1) && step === 0) setShowBtns(true);
  }, [step, stepVisited, currentPage]);

  const titles: Record<number, string> = {
    0: "Engage users with AI-powered\npersonalized content tailored to\ntheir preferences",
    1: "Switch Profiles Effortlessly",
  };

  const description: Record<number, string> = {
    0: `“Seamless Entertainment, Smarter Than Ever.”\nExperience a next-generation entertainment\nplatform designed to bring content closer to you.\nPowered by advanced AI, your viewers can enjoy\nhyper-personalized content, accessible anytime,\nanywhere.\n
      <b style="text-decoration: underline;">Switch Profile</b>\nTap here to personalize recommendations for\nevery family member.`,
    1: "Welcome to personalized entertainment.\n\nSwitch profiles with ease to ensure each family\nmember enjoys recommendations tailored to their\ntastes.\n\nWhether it’s action-packed adventures,\nheartwarming dramas, or kids’ cartoons, your\nentertainment is always just right.\nChanging profiles lets the AI curate content and\npreferences based on viewing history. Dive back\ninto your favorite shows or explore something new,\nall personalized just for you.",
  };

  const backButtonConfig = (() => {
    return {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => (showBtns ? setCurrentPage(BackPageId) : null),
      style: {
        transition: "opacity 0.5s",
        gap: "var(--width-16)",
        opacity: showBtns ? 1 : 0,
      },
    };
  })();

  const nextButtonConfig = (() => {
    return {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => (showBtns ? setCurrentPage(NextPageId) : null),
      style: {
        transition: "opacity 0.5s",
        gap: "var(--width-16)",
        opacity: showBtns ? 1 : 0,
      },
    };
  })();

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title: titles[step],
    description: description[step],
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollTop={step === 1}>
          <MainScreen pageId={PageId} step={step} setStep={registerStepVisited} stepVisited={stepVisited} />
        </FrameTV>
        <BottomTV showSkips={!stepVisited.includes(1)} backPageId={BackPageId} nextPageId={NextPageId} />
      </PanelRight>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
